const BASE_URL = process.env.REACT_APP_API_BASE_URL;

const handleError = async (response, fallbackMessage = "حدث خطأ غير متوقع") => {
    let message = fallbackMessage;
    try {
        const data = await response.json();
        message = data?.message || data?.error || fallbackMessage;
    } catch (_) {
        try {
            const text = await response.text();
            message = text || fallbackMessage;
        } catch (_) { }
    }

    console.error(`API Error [${response.status}]: ${message}`);
    throw new Error(message);
};

export const getAllInstitutions = async (filters = {}) => {
    const params = Object.entries(filters)
        .filter(([_, value]) => value !== null && value !== undefined && value !== '')
        .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
        .join('&');

    const response = await fetch(`${BASE_URL}/institution?${params}`);

    if (!response.ok) {
        await handleError(response, "حدث خطأ أثناء تحميل المؤسسات");
    }

    return await response.json();
};

export const getInstitutionDetails = async (id) => {
    const response = await fetch(`${BASE_URL}/institution/${id}`);

    if (!response.ok) {
        await handleError(response, "حدث خطأ أثناء تحميل تفاصيل المؤسسة");
    }

    return await response.json();
};

export const updateInstitutionDetails = async (id, data, token) => {
    console.log("🟡 updateInstitutionDetails called with:");
    console.log("ID:", id);
    console.log("Token:", token);
    if (data instanceof FormData) {
        for (let [key, value] of data.entries()) {
            console.log("📦 FormData Entry:", key, value);
        }
    } else {
        console.log("Data being sent (not FormData):", data);
    }

    const response = await fetch(`${BASE_URL}/institution/${id}`, {
        method: "PUT",
        headers: {
            Authorization: `Bearer ${token}`, // ✅ DO NOT set 'Content-Type' for FormData
        },
        body: data,
    });

    if (!response.ok) {
        await handleError(response, "حدث خطأ أثناء تحديث بيانات المؤسسة");
    }

    return await response.json();
};

